import { render, staticRenderFns } from "./AddProviderDetailedInfo.vue?vue&type=template&id=21dc3c9a"
import script from "./AddProviderDetailedInfo.vue?vue&type=script&lang=js"
export * from "./AddProviderDetailedInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports